import React from "react";
import { useSelector } from "react-redux";
import ThreadHelper from "../../../../entities/thread/thread-helper";

const Thread = ({
  userImg,
  userInitials,
  userName,
  message,
  date,
  unreadCount,
  threadId,
  isActive,
  thread,
}) => {
  const { userInfo } = useSelector((state) => state.userStore);

  // Get B2C users from a thread's _users array
  const getB2cUsers = () => {
    if (!thread?._users || !Array.isArray(thread._users)) return [];
    return thread._users.filter(user => user.role === 'b2c');
  };

  const b2cUsers = getB2cUsers();
  const showB2cBadge = userInfo?.role !== 'b2c' && b2cUsers.length > 0;

  const getInitials = (input) => {
    if (typeof input !== "string" || !input.trim()) {
      return ["U1", "U2"];
    }

    // Split the string using '&' only
    let names = input.split(/\s*&\s*/).map((name) => name.trim());

    // Extract initials
    let initials = names.map((name) => {
      let parts = name.split(/\s+/).filter(Boolean); // Split by space and remove empty parts
      if (parts.length === 1) return parts[0][0].toUpperCase(); // Single name case
      return parts.map((part) => part[0].toUpperCase()).join("");
    });

    return initials.length >= 2 ? initials : ["U1", "U2"];
  };
  const roomInitials = getInitials(userName);
  return (
    <a
      href="#"
      className={`media ${isActive ? "new-message" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        ThreadHelper.makeThreadActive(thread);
      }}
    >
      <div className="media-left ">
        {/* If user image exists, show it, otherwise show initials */}
        {userImg ? (
          // <img src={userImg} alt="user" className="rounded-circle thumb-md" />

          <div className="roomInitials">
            <div className="initial one">{roomInitials[0]}</div>
            <div className="initial two">{roomInitials[1]}</div>
          </div>
        ) : (
          <div className="avatar-box thumb-md align-self-center">
            <span className="thumb-md justify-content-center d-flex align-items-center bg-soft-primary rounded-circle">
              {userInitials}
            </span>
          </div>
        )}
        {thread?.type === "room" &&
          thread.lastMessagePreview.indexOf("left the room") === -1 && (
            <span className="round-10 bg-success" />
          )}
      </div>
      <div className="media-body">
        <div className="d-inline-block">
          <h6>
            {userName}
            {showB2cBadge && (
              <span
                className="b2c-badge-inline"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  marginLeft: '8px',
                  padding: '3px 8px',
                  fontSize: '9px',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  backgroundColor: '#dbeafe',
                  color: '#1e40af',
                  borderRadius: '12px',
                  verticalAlign: 'middle',
                  textTransform: 'uppercase',
                  border: '1px solid #bfdbfe'
                }}
              >
                <svg 
                  width="10" 
                  height="10" 
                  viewBox="0 0 16 16" 
                  fill="currentColor" 
                  style={{ marginRight: '4px' }}
                >
                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                </svg>
                Co-ordinator
              </span>
            )}
          </h6>
          <p>{message}</p>
          {showB2cBadge && (
            <div style={{ 
              marginTop: '6px',
              padding: '6px 8px',
              backgroundColor: '#f8fafc',
              borderRadius: '6px',
              borderLeft: '3px solid #3b82f6'
            }}>
              {b2cUsers.map((user, idx) => (
                <div 
                  key={user._id || idx} 
                  style={{ 
                    fontSize: '11px',
                    lineHeight: '1.5',
                    marginBottom: idx < b2cUsers.length - 1 ? '4px' : '0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  <svg 
                    width="12" 
                    height="12" 
                    viewBox="0 0 16 16" 
                    fill="#3b82f6"
                    style={{ flexShrink: 0 }}
                  >
                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004c.08-.06.162-.116.243-.17L8 12.5l-.229.326ZM8 12.5a4.5 4.5 0 0 1-.229-.67c.078-.059.155-.115.229-.17L8 12.5ZM7 13.256a4.474 4.474 0 0 1 .229-1.004A3.07 3.07 0 0 1 8 12.5c.256 0 .504.036.736.104.149.044.292.101.429.17.137.069.266.15.387.242.121.093.233.198.336.313s.194.242.273.379.142.282.19.436.073.318.08.493v.02c0 .414-.112.799-.307 1.131a2.001 2.001 0 0 1-.763.716 2.052 2.052 0 0 1-.361.174c-.121.047-.246.079-.376.095H8a2 2 0 0 1-1-3.744Z"/>
                  </svg>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1 }}>
                    <span style={{ 
                      fontWeight: '600', 
                      color: '#1e293b',
                      fontSize: '11px'
                    }}>
                      {user.name || 'N/A'}
                    </span>
                    <span style={{ 
                      color: '#64748b',
                      fontSize: '10px',
                      fontStyle: 'italic'
                    }}>
                      {user.email || 'No email'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <span className="time">
            {ThreadHelper.getFormattedDateTime(date)}
          </span>
          {unreadCount > 0 ? <span>{unreadCount}</span> : ""}
        </div>
      </div>
    </a>
  );
};

export default Thread;
